import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=2a8039d1&functional=true"
var script = {}
import style0 from "./VPagination.vue?vue&type=style&index=0&id=2a8039d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports